export default "__VITE_ASSET__9318cafe__"